import { axiosApi } from "../axios";
import { followByMessages, followedConversations, messagesSummary, followByConversations } from "../types/following";

//for following with selected messages
export const followConversation = async (userId: string, itemIds: string[]) => {
  const followConversations: followByMessages = {
    messages: itemIds.map((itemId) => ({
      id: itemId,
    })),
  };
  await axiosApi.post(`/users/${userId}/follow`, followConversations);

  return { success: true };
};

//for unfollowing with selected messages
export const unfollowByMessage = async (userId: string, itemIds: string[]) => {
  const followConversations: followByMessages = {
    messages: itemIds.map((itemId) => ({
      id: itemId,
    })),
  };

  await axiosApi.post(`/users/${userId}/unfollow`, followConversations);

  return { success: true };
};

//for unfollowing with selected conversations
export const unfollowByConversation = async (userId: string, conversationIds: string[]) => {
  const followConversations: followByConversations = {
    conversations: conversationIds.map((itemId) => ({
      id: itemId,
    })),
  };

  await axiosApi.post(`/users/${userId}/unfollow`, followConversations);

  return { success: true };
};

export const getMessageSummary = async (userId: string, itemIds: string[]
): Promise<messagesSummary> => {
  const summaryMessages: followByMessages = {
    messages: itemIds.map((itemId) => ({
      id: itemId,
    })),
  };
  const response = await axiosApi.post<messagesSummary>(`/users/${userId}/summarise`, summaryMessages);
  return response.data;
};

export const getConversationSummary = async (userId: string, conversationIds: string[]
): Promise<messagesSummary> => {
  const summaryConversations: followByConversations = {
    conversations: conversationIds.map((conversationId) => ({
      id: conversationId,
    })),
  };
  const response = await axiosApi.post<messagesSummary>(`/users/${userId}/summarise`, summaryConversations);
  return response.data;
};

//todo implement for streamed API response
// export const getMessageSummary = async (
//   userId: string,
//   itemId: string
// ): Promise<messagesSummary> => {
//   const response = await axiosApi.get(`/users/${userId}/follow/${itemId}`, {
//     responseType: 'stream',
//   });

//   const reader = response.data.getReader();
//   const decoder = new TextDecoder("utf-8");
//   let result = "";
//   let done = false;

//   while (!done) {
//     const { value, done: doneReading } = await reader.read();
//     done = doneReading;
//     result += decoder.decode(value, { stream: true });
//   }

//   return JSON.parse(result);
// };

export const getFollowedConversations = async (userId: string): Promise<followedConversations> => {
  const response = await axiosApi.get<followedConversations>(`/users/${userId}/FollowedConversations`);

  return response.data;
}